import {useQuery} from '@apollo/client';
import {useBuilderContext} from '../CreateBuilder/useBuilderContext';
import {useAutoForm} from '../../../components/AutoForm/useAutoForm';
import {sanitiseProductType} from '../../../utils/sanitiseProductType';
import validateUUID from '../../../utils/validateUUID';
import {BUILDER_WITHDRAW_POTS} from '../builderPotQueries';
import {reccNonEditable} from '../CreateBuilder/BuilderSourceDestination/CreateBuilderFooter';
import {builderFieldsType} from '../CreateBuilder/builderFields';
import {BuilderPot} from '../../../schema-types/BuilderPot';
import {
  BuilderWithdrawPots,
  BuilderWithdrawPotsVariables,
} from '../../../schema-types/BuilderWithdrawPots';
import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';

export const useWithdrawalPotsQuery = (): {
  sourcePots: BuilderPot[];
  destinationPots: BuilderPot[];
} => {
  const {builderDetails, builderReviewId} = useBuilderContext();
  const {values} = useAutoForm<builderFieldsType>();
  const contactId = values.contact ? validateUUID(values.contact) || null : null;
  const isNonEditable = !!reccNonEditable(builderDetails);

  const {data: potsData} = useQuery<BuilderWithdrawPots, BuilderWithdrawPotsVariables>(
    BUILDER_WITHDRAW_POTS,
    {
      variables: {
        reviewId: validateUUID(builderReviewId)!,
        contactId,
        potType: sanitiseProductType(values.mainPlanType) ?? '',
      },
      skip:
        isNonEditable ||
        values.planAction !== OVRecommendActionEnum.WITHDRAW ||
        !values.mainPlanType ||
        !validateUUID(builderReviewId),
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    }
  );

  if (isNonEditable) {
    const savedSource = builderDetails?.withdraw?.sourcePot;
    const savedDestination = builderDetails?.withdraw?.destinationPot;
    return {
      sourcePots: savedSource ? [savedSource] : [],
      destinationPots: savedDestination ? [savedDestination] : [],
    };
  }

  return {
    sourcePots: potsData?.withdrawPots?.sources ?? [],
    destinationPots: potsData?.withdrawPots?.destinations ?? [],
  };
};
